import { CheckIcon, PencilIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Fragment, useContext, useEffect, useState } from "react";
import config from "../../config";
import { getUserToken } from "../../contexts/AuthContext";
import { NotificationContext } from "../../contexts/NotificationContext";
import { CountryContext } from "../../pages/CountryWrapper";

function CountryTranslationLine(props) {
    const [country, setCountry] = useContext(CountryContext);
    const { addNotification } = useContext(NotificationContext);
    const [editing, setEditing] = useState(false);
    const [name, setName] = useState('');
    const [languageCode, setLanguageCode] = useState('');

    useEffect(() => {
        if (props.translation.name && props.translation.language_code) {
            setName(props.translation.name);
            setLanguageCode(props.translation.language_code);
        }
    }, [props]);

    useEffect(() => {
        if (!props.editing) {
            setEditing(false);
        }
    }, [props.editing]);

    function editTranslation(event) {
        event.preventDefault();
        editCountryTranslation();
    };

    async function editCountryTranslation() {
        const token = await getUserToken();
        const res = await fetch(`${config.geoid_url_v3}/v2/Country/Translation/${props.translation.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                name,
                language_code: languageCode,
            })
        });

        if (res.status === 200) {
            let copy = { ...country };
            const index = copy.translations.findIndex((item) => item.id === props.translation.id);

            copy.translations[index].name = name;
            copy.translations[index].language_code = languageCode;

            setEditing(false);
            setCountry(copy);
            addNotification('Translation was editted successfully', 'SUCCESS');
        }
    }

    async function deleteTranslation() {
        const token = await getUserToken();
        const res = await fetch(`${config.backend_url}/v1/country/translation`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                translation_id: Number(props.translation.id),
                country_id: Number(country.geonames_id)
            })
        });

        if (res.status === 204) {
            const filteredList = country.translations.filter((item) => item.id !== props.translation.id);
            let copy = { ...country };
            copy.translations = filteredList;

            setCountry(copy);
            addNotification('Translation was removed from the country successfully', 'SUCCESS');
        }
    }

    return (
        <div className="flex justify-between center-items bg-white px-6 py-2">
            <div className="flex w-full">
                {!editing && <Fragment>
                    <div className="w-1/6 pl-3 text-sm font-medium text-gray-500">
                        {props.translation.language_code}
                    </div>

                    <div className="w-full pl-3 mt-1 ml-8 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        {props.translation.name}
                    </div>
                </Fragment>}

                {(props.editing && !editing) && <div className="flex ml-auto">
                    <button
                        onClick={() => { setEditing(true) }}
                        type="button"
                        className="inline-flex items-center px-2 py-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
                        Edit
                        <PencilIcon className="ml-1 h-4 w-4"></PencilIcon>
                    </button>

                    <button
                        onClick={deleteTranslation}
                        type="button"
                        className="ml-2 inline-flex items-center px-2 py-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-300">
                        Remove
                        <XMarkIcon className="ml-1 h-5 w-5" />
                    </button>
                </div>}

                {(editing && props.editing) && <div className="flex w-full">
                    <form onSubmit={editTranslation} className="flex items-stretch flex-grow focus-within:z-10">
                        <input
                            value={languageCode}
                            onChange={(e) => setLanguageCode(e.target.value)}
                            type="text"
                            name="language-code"
                            id="language-code"
                            className="focus:ring-blue-500 focus:border-blue-500 block w-1/6 rounded-none rounded-md sm:text-sm border-gray-300"
                            placeholder="nl or en_US" />

                        <input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            type="text"
                            name="name"
                            id="name"
                            className="ml-4 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-none rounded-md sm:text-sm border-gray-300"
                            placeholder="Nederland or Нидерланды" />

                        <button
                            type="submit"
                            className="ml-4 inline-flex items-center px-2 py-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700">
                            Save
                            <CheckIcon className="ml-1 h-4 w-4"></CheckIcon>
                        </button>
                    </form>
                </div>}
            </div>
        </div>
    )
}

export default CountryTranslationLine;